import fetchEnv from "./FetchEnv";

const env = fetchEnv();
const azure_client_id = env?.REACT_APP_SSO_OUTLOOK_LOGIN_AZURE_CLIENT_ID;
const authority_url = env?.REACT_APP_SSO_AUTHORITY_URL;
const redirect_url = env?.REACT_APP_SSO_REDIRECT_URL;

export const msalConfig = {
  auth: {
    clientId: azure_client_id,
    authority: authority_url,
    redirectUri: redirect_url,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
  prompt: "select_account",
};
